import $ from 'jquery';

$.addInit(function(context) {
	var base = '.i-showYoutubeVideo';
	$(base, context).each(function(){
		var component = $(this);

		component.click(function (e) {
			e.preventDefault();

			var $link = $(this);

			if ($link.find('iframe').length)
				return;

			var youtubeVideoUrl = 'https://www.youtube.com/embed/' + $link.data('video-id') + '?autoplay=1&enablejsapi=1';

			$link.parent().html('<iframe id="' + $link.data('video-id') + '" type="text/html" width="300" height="249" src="' + youtubeVideoUrl + '" frameborder="0" allowfullscreen="allowfullscreen"></iframe>');
		});
	});
});


//////////////////
// WEBPACK FOOTER
// ./src/components/i-showYoutubeVideo.js
// module id = 68
// module chunks = 0